import { extendTheme } from "@chakra-ui/react";
const config = {
    useSystemColorMode: true,
};
const globalStyle = {
    styles: {
        global: {
            "html, body, #app": {
                height: "100%",
                width: "100%",
            },
        },
    },
};
export const theme = extendTheme(Object.assign({ config }, globalStyle));
